(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-brands-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.currentScript ? null : null;
  var section = document.querySelector('.rb-brandspage');
  if (!section) return;
  var statusEl = section.querySelector('[data-brands-status]');
  var bodyEl = section.querySelector('[data-brands-body]');
  var input = section.querySelector('#rb-brandsearch-input');

  function vendorUrl(v) { return '/collections/vendors?q=' + encodeURIComponent(v); }
  function norm(s) { return (s || '').toLowerCase(); }

  async function loadVendors() {
    var counts = {};
    var page = 1;
    while (page <= 20) {
      var res = await fetch('/collections/all/products.json?limit=250&page=' + page, { headers: { Accept: 'application/json' } });
      if (!res.ok) break;
      var data = await res.json();
      var products = data.products || [];
      products.forEach(function (p) { if (p.vendor) counts[p.vendor] = (counts[p.vendor] || 0) + 1; });
      if (products.length < 250) break;
      page++;
    }
    return counts;
  }

  function render(counts) {
    var names = Object.keys(counts).sort(function (a, b) { return a.localeCompare(b, 'de', { sensitivity: 'base' }); });
    if (!names.length) { statusEl.textContent = 'Keine Marken gefunden.'; return; }
    var groups = {};
    names.forEach(function (n) {
      var ch = n.charAt(0).toUpperCase();
      if (!/[A-ZÄÖÜ]/.test(ch)) ch = '#';
      (groups[ch] = groups[ch] || []).push(n);
    });
    var html = '';
    Object.keys(groups).sort(function (a, b) { return a.localeCompare(b, 'de'); }).forEach(function (letter) {
      html += '<div class="rb-brandsgroup" data-group>'
        + '<div class="rb-brandsgroup__letter">' + letter + '</div>'
        + '<div class="rb-brandsgrid">'
        + groups[letter].map(function (n) {
            return '<a class="rb-brandcard" data-brand="' + norm(n) + '" href="' + vendorUrl(n) + '">'
              + '<span class="rb-brandcard__name"></span>'
              + '<span class="rb-brandcard__count">' + counts[n] + '</span></a>';
          }).join('')
        + '</div></div>';
    });
    bodyEl.innerHTML = html;
    // set names via textContent to avoid HTML injection from vendor strings
    var cards = bodyEl.querySelectorAll('.rb-brandcard');
    var i = 0;
    Object.keys(groups).sort(function (a, b) { return a.localeCompare(b, 'de'); }).forEach(function (letter) {
      groups[letter].forEach(function (n) { cards[i].querySelector('.rb-brandcard__name').textContent = n; i++; });
    });
    statusEl.hidden = true;
    bodyEl.hidden = false;
    var empty = document.createElement('div');
    empty.className = 'rb-brandspage__empty'; empty.hidden = true; empty.textContent = 'Keine Marke passt zu deiner Suche.';
    bodyEl.appendChild(empty);

    input.addEventListener('input', function () {
      var q = norm(input.value.trim());
      var anyVisible = false;
      bodyEl.querySelectorAll('[data-group]').forEach(function (g) {
        var groupHas = false;
        g.querySelectorAll('.rb-brandcard').forEach(function (c) {
          var match = !q || c.getAttribute('data-brand').indexOf(q) >= 0;
          c.style.display = match ? '' : 'none';
          if (match) { groupHas = true; anyVisible = true; }
        });
        g.style.display = groupHas ? '' : 'none';
      });
      empty.hidden = anyVisible;
    });
  }

  loadVendors().then(render).catch(function (e) {
    console.error('[RB Brands]', e);
    statusEl.textContent = 'Marken konnten nicht geladen werden.';
  });
})();

  } catch(e) { console.error(e); }
})();
})();
